// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1_r0O","colMin":"styles_colMin__1IHGw","colCheckbox":"styles_colCheckbox__5Whpk"};